import { ActionIcon, Group, Tooltip } from "@mantine/core";
import {
  IconCheck,
  IconEdit,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import type { ColumnDef } from "@tanstack/react-table";
import type { IEquipo } from "../../../modelos/Equipo/entidades/IEquipo";

interface ColumnasTablaEquipoParams {
  manejarEdicionEquipo: (cliente: IEquipo) => void;
  manejarEliminacionEquipo: (cliente: IEquipo) => void;
}

export const columnasTablaEquipo = ({
  manejarEdicionEquipo,
  manejarEliminacionEquipo,
}: ColumnasTablaEquipoParams): ColumnDef<IEquipo>[] => [
    {
      id: "actions",
      header: "Acciones",
      cell: ({ row: fila }) => (
        <Group gap={4} justify="center">
          <Tooltip label="Editar" style={{ fontSize: '10px', padding: '3px 5px' }} withArrow>
            <ActionIcon
              color='var(--mantine-color-primary-0)'
              variant="transparent"
              radius="sm"
              size="sm"
              onClick={() => manejarEdicionEquipo(fila.original)}
            >
              <IconEdit size={18} />
            </ActionIcon>
          </Tooltip>
          <Tooltip style={{ fontSize: '10px', padding: '3px 5px' }} label="Eliminar" withArrow>
            <ActionIcon
              color="var(--mantine-color-primary-0)"
              variant="transparent"
              radius="sm"
              size="sm"
              onClick={() => manejarEliminacionEquipo(fila.original)}
            >
              <IconTrash size={18} />
            </ActionIcon>
          </Tooltip>
        </Group>
      ),
    },
    { accessorKey: "Codigo", header: "Código", enableSorting: true },
    { accessorKey: "Nombre", header: "Nombre Equipo", enableSorting: true },
    { accessorKey: "TipoEquipo.Nombre", header: "Tipo Equipo", enableSorting: true },
    { accessorKey: "Marca.Nombre", header: "Marca", enableSorting: true },
    { accessorKey: "Modelo.Nombre", header: "Modelo", enableSorting: true },
    {
      accessorKey: "Adoptado",
      header: "Adoptado",
      enableSorting: true,
      cell: ({ row }) => {
        const adoptado = row.original.Adoptado;

        return (
          <Group justify="center">
            {adoptado ? (
              <IconCheck size={18} color="var(--mantine-color-primary-0)" stroke={2} />
            ) : (
              <IconX size={18} color="red" stroke={2} />
            )}
          </Group>
        );
      },
    },

    { accessorKey: "EstadoEquipo.Nombre", header: "Estado", enableSorting: true },
  ];
